import { CheckConfig } from '@customer/config/check.config';
import { LoginConfig } from '@customer/config/login.config';
import { SignupConfig } from '@customer/config/signup.config';
import { RecoverPasswordConfig } from '@customer/config/recoverPassword.config';

import { FormBuilderConfig } from '@customer/types/formBuilder';

type Configs = Record<string, CheckConfig | LoginConfig | SignupConfig | RecoverPasswordConfig>;

export class FormBuilder {
  public config: FormBuilderConfig;
  private formType = 'login';

  constructor(configs: Configs) {
    this.config = this.createConfig(configs);
  }

  private createConfig(configs: Configs) {
    const config: any = {
      data: {},
      html: {},
      validations: {},
    };
    const keys = Object.keys(configs);

    for (const key of keys) {
      config.data[key] = configs[key].data;
      config.html[key] = configs[key].html;
      config.validations[key] = configs[key].validations;
    }

    config.data.formType = this.formType;
    config.validations.validationGroup = keys;

    return config as FormBuilderConfig;
  }

  public resetData(data: { [key: string]: any }) {
    for (const input in data) {
      data[input] = null;
    }
  }
}
